<template>
    <div class="d-flex content-config-cluster" id="content-config-cluster">
        <!-- <LoaderInfo></LoaderInfo> -->
        <div class="col-3">
            <FrameOpenClose title="Clusters">
                <!-- eslint-disable-next-line vue/require-v-for-key -->
                <div v-for="cluster in getClusters">{{ cluster.name }}</div>
                <button class="btn" @click="save">Save</button>
            </FrameOpenClose>
        </div>
        <div class="col-7">
            <TemplatePlano v-if="clusterSelected != null" :data="clusterSelected" />
            <!-- <svg id="cluster" class="cluster-builder" width="100%" height="100%"></svg> -->
        </div>
        <div class="col-2"><Elements :cluster="1" /></div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { utilsMixin } from "../mixins/utils";
import FrameOpenClose from "./FrameOpenClose";
import LoaderInfo from "./../../common/LoaderInfo";
import Elements from "../common/Elements";
import TemplatePlano from "../common/TemplatePlano";

// const d3 = require('d3')

export default {
    components: {
        FrameOpenClose,
        LoaderInfo,
        Elements,
        TemplatePlano
    },
    mixins: [utilsMixin],
    data() {
        return {
            clusterSelected: null
        };
    },

    // watch: {
    //     onCopyElement (value) {
    //         // console.log(value)
    //         this.copyElement(value)
    //     }
    // },

    computed: {
        ...mapGetters("planonext/carcass/", {
            getClusters: "getClusters"
        }),

        ...mapGetters("planonext/plano/", {
            getGroups: "getGroups",
            getDividers: "getDividers"
        }),

        ...mapGetters("events", {
            onCopyElement: "onCopyElement"
        })
    },
    created() {
        // let id = this.$route.params.id
        // this.loadClusterByCarcassId(id)
    },
    mounted() {
        let id = this.$route.params.id;
        this.loadClusterByCarcassId(id).then(res => {
            let cluster = this.getClusters[0];
            // console.log(cluster)
            this.clusterSelected = cluster;
            // this.loadCarcass(cluster)
            // this.drawCarcass()
            // this.initListeners()
            // this.loadComponents(cluster)
        });
    },

    beforeDestroy() {
        this.cleanState();
    },

    methods: {
        ...mapActions("planonext/carcass/", {
            load: "load",
            cleanState: "cleanState",
            loadClusterByCarcassId: "loadClusterByCarcassId",
            loadCarcass: "loadCarcass",
            saveCluster: "saveCluster"
        }),

        save() {
            let config = {
                groups: this.getGroups,
                dividers: this.getDividers
            };
            // console.log(config)
            this.saveCluster({ id: this.clusterSelected.id, config });
        }
    }
};
</script>

<style scoped lang="scss">
.content-config-cluster {
    width: 100%;
    height: calc(100vh - 300px);
}
</style>



// WEBPACK FOOTER //
// Cluster.vue?458b8232